module.exports = __webpack_public_path__ + "static/media/sarah-lose.499bbf91.png";